import { useState } from "react";
import { toDatetimeLocal } from "../../utils/dateUtils";

export default function IllnessForm({ onAdd }) {
  const [date, setDate] = useState(() => toDatetimeLocal());
  const [symptoms, setSymptoms] = useState("");
  const [severity, setSeverity] = useState("mild");
  const [notes, setNotes] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!symptoms) return;

    onAdd({
      date: new Date(date).toISOString(),
      symptoms: symptoms,
      severity: severity,
      notes: notes || "",
      type: "illness"
    });

    setDate(toDatetimeLocal());
    setSymptoms("");
    setSeverity("mild");
    setNotes("");
  };

  return (
    <form onSubmit={handleSubmit} className="mb-3">
      <div className="row g-2 mb-2">
        <div className="col-md-4">
          <label className="form-label">Date & Time</label>
          <input
            type="datetime-local"
            className="form-control"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            required
          />
        </div>
      </div>
      <div className="row g-2">
        <div className="col-md-4">
          <label className="form-label">Symptoms</label>
          <input
            type="text"
            className="form-control"
            placeholder="e.g. Cough, fever, runny nose"
            value={symptoms}
            onChange={(e) => setSymptoms(e.target.value)}
            required
          />
        </div>
        <div className="col-md-2">
          <label className="form-label">Severity</label>
          <select
            className="form-select"
            value={severity}
            onChange={(e) => setSeverity(e.target.value)}
          >
            <option value="mild">Mild</option>
            <option value="moderate">Moderate</option>
            <option value="severe">Severe</option>
          </select>
        </div>
        <div className="col-md-3">
          <label className="form-label">Notes</label>
          <input
            type="text"
            className="form-control"
            placeholder="Treatment, duration, etc."
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
          />
        </div>
        <div className="col-md-3 d-flex align-items-end">
          <button type="submit" className="btn btn-danger w-100">
            Log Illness
          </button>
        </div>
      </div>
    </form>
  );
}
